import { type GridCellParams } from '@mui/x-data-grid'
import { generateCell, toCamelCase } from './generateCells'
import { type CustomColumnDef } from './types'

export const generateColumns = <T,>(columns: CustomColumnDef[], extraColumnProps: object | undefined, overrides: Record<string, (a: T) => JSX.Element>, setSelectedRow: any, setActionModal: any, headerOverrides: Record<string, (headerName: string) => JSX.Element> = {}, rowLevelWarningKeys: string[] = []): CustomColumnDef[] => {
  const filterdColumn = columns?.filter((column: CustomColumnDef) => column.shown)

  return filterdColumn?.map((column, index) => {
    const headerOverride = headerOverrides[toCamelCase(column?.field)] ?? headerOverrides[column?.field]
    return {
      field: column?.field,
      headerName: column?.headerName,
      flex: 1,
      minWidth: 160,
      maxWidth: 400,
      type: column.type,
      sortable: column.allowSort ?? false,
      hideable: column.alwaysShow === false,
      shown: column.shown ?? false,
      sortingOrder: ['asc', 'desc'],
      ...extraColumnProps,
      ...(headerOverride != null ? { renderHeader: () => headerOverride(column?.headerName) } : {}),
      renderCell: ({ id, colDef, row }: GridCellParams) => generateCell(String(id), colDef, row, setSelectedRow, setActionModal, index, overrides, rowLevelWarningKeys)
    }
  })
}
